/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Force_End_Error_Already_ClosedInputs */

const vi_trip_force_end_error_already_closed = /** @type {(inputs: Trip_Force_End_Error_Already_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyến đã được kết thúc từ trước`)
};

/**

* @param {Trip_Force_End_Error_Already_ClosedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_force_end_error_already_closed = /** @type {((inputs?: Trip_Force_End_Error_Already_ClosedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Force_End_Error_Already_ClosedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_force_end_error_already_closed(inputs)
});